<template>
  <ContentSection>
    <Container indent="lg-but-on-mobile-default">
      <div
        class="
          flex w-full max-w-container-text flex-col gap-8 rounded-tr-100 bg-grey-100 p-container pb-8
          lg:flex-row lg:gap-16 lg:p-6
          md:p-container-lg
          sm:gap-10
        "
      >
        <!-- CHART -->
        <div
          v-if="dataRows"
          v-animate-zoom-in
          class="aspect-square max-h-[80vh] w-full overflow-hidden bg-white lg:w-1/2 max-lg:rounded-tr-[80px]"
        >
          <ChartPie
            :chart-data="dataRows"
            :unit="data.unit"
            :unit-prefix="data.unit_prefix"
            :segment-config="segmentConfigs"
          />
        </div>

        <!-- TEXT -->
        <div v-animate-children-in-from-bottom class="w-full lg:w-1/2 lg:pb-10 lg:pr-12 lg:pt-12">
          <!-- Header -->
          <h2
            v-if="data.heading"
            class="mb-2 typo-heading-md"
            v-html="data.heading"
          />
          <!-- Text -->
          <div
            v-if="data.text"
            class="typo-body-xl"
            v-html="data.text"
          />

          <!-- Legend -->
          <ul class="mt-5 space-y-2 sm:mt-6">
            <li
              v-for="(row, index) in dataRows"
              :key="index"
              class="flex w-full items-center justify-between gap-5"
            >
              <span>{{ segmentConfigs?.[index]?.title || row.cells[0] }}</span>
              <span>
                <span v-if="props.data.unit_prefix">{{ props.data.unit }}</span>
                <span>{{ row.cells.slice(1).reduce((sum, cell) => sum + parseFloat(cell || '0'), 0) }}</span>
                <span v-if="!props.data.unit_prefix">{{ props.data.unit }}</span>
              </span>
            </li>
          </ul>
        </div>
      </div>
    </Container>
  </ContentSection>
</template>

<script lang="ts" setup>
import type { ComponentsMainChartCircleFragment } from '#gql'

const props = defineProps<{
  data: Enforce<ComponentsMainChartCircleFragment>
}>()
const dataRows = computed(() => {
  return props.data.chart_data
})

const segmentConfigs = computed(() => {
  return props.data.segment_config
})
</script>
